import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import photo01 from '../../../assets/news/news.jpg'
import photo02 from '../../../assets/news/news2.jpg'
import photo03 from '../../../assets/news/news3.jpg'
import photo04 from '../../../assets/news/news_03_10.jpg'
import photo05 from '../../../assets/news/news_04_11.jpeg'

export interface INewsItem {
	published: string
	imageUrl: string
	title: string
	content: string
}

interface INewsState {
	news: INewsItem[]
}

const initialState: INewsState = {
	news: [
		{
			published: '10/29/2023',
			content:
				'<p>SAIRUS p2p trades automatically, and you can monitor all the processes of trading operations online in your personal account.</p><a href="https://sairus.net/p2p/">https://sairus.net/p2p/</a><a href="https://t.me/SairusEnglish">https://t.me/SairusEnglish</a>',
			imageUrl: `${photo01}`,
			title: 'SAIRUS - P2P TRADING STATISTICS',
		},
		{
			published: '11/5/2023',
			content:
				'<p>The SAIRUS system is fully automated. Artificial intelligence allows the system to independently use more 30 proven and tested market strategies.</p><p>SAIRUS p2p is able to act independently, without human intervention, imitating the thinking of analysts, as well as constantly improve itself.</p><p>SAIRUS p2p works 24/7 on any market conditions, without excitement and emotional involvement in the process, thereby minimizing the mistakes of the notorious human factor.</p>',
			imageUrl: `${photo02}`,
			title: 'Sairus p2p statistics from October 30 to November 5.',
		},
		{
			published: '11/12/2023',
			content:
				'<p>SAIRUS p2p trades automatically, and you can monitor all the processes of trading operations online in your personal account.</p><a href="https://sairus.net/p2p/">https://sairus.net/p2p/</a><a href="https://t.me/SairusEnglish">https://t.me/SairusEnglish</a>',
			imageUrl: `${photo03}`,
			title: 'SAIRUS - P2P TRADING STATISTICS. November 6 - 12',
		},
		{
			published: '10/03/2025',
			content:
				"<p>Dear friends, we are glad to inform you that from 03/10/2025 to 04/10/2025 we are holding a contest for the best video feedback about SAIRUS. All participants of the contest receive $10 each to their personal account balance. 1st place gets $100, 2nd place $50, 3rd place $30. Terms of participation - you must be a registered user on the company's official website</p><a href='https://sairus.net'>https://sairus.net</a><p>you must have a valid deposit, the video must be posted on</p><a href='https://www.youtube.com'>https://www.youtube.com </a><p>where our website will be demonstrated. Send the link to the video review by email</p><a href='mailto:sairusltd@gmail.com'>sairusltd@gmail.com</a>",
			imageUrl: `${photo04}`,
			title: 'Competition for the best video review',
		},
		{
			published: '11/04/2025',
			content:
				"<p>We are thrilled to share some exciting news that will surely delight our friends from India!  Our <a href='https://sairus.net/'>SAIRUS</a> website is now available in Hindi! This incredible update opens up new horizons and allows you to easily and comfortably access all the services and information we offer.</p><p>We believe that the addition of the Hindi language on our website will make communication smoother and more accessible for all our users from India. Now, you can not only explore our services but also receive all the necessary information in your native language! </p><p>We strive to make your interaction with <a href='https://sairus.net/'>SAIRUS</a> as convenient and efficient as possible. Enjoy the new experience and discover all the opportunities that our service offers in Hindi.</p><p>Thank you for your support and attention. We look forward to your feedback! Happy browsing!</p><h3>From the <a>SAIRUS</a> team!</h3>",
			imageUrl: `${photo05}`,
			title: 'Hello India',
		},
	],
}

const newsSlice = createSlice({
	name: 'referrals',
	initialState,
	reducers: {
		setNews: (state, action: PayloadAction<INewsItem[]>) => {
			state.news = [...action.payload]
		},
	},
})

export const { setNews } = newsSlice.actions
export default newsSlice.reducer
